import React from "react";

import Image from "../image";

const SalesTeamCard = ({
  profile = {},
  outerContainerClass = "flex flex-col bg-white shadow-lg py-5 px-5 rounded-md gap items-center",
  imageContainerClass = "flex items-center bg-white rounded-full w-16 h-16 xl:w-24 xl:h-24 mb-4 relative overflow-hidden",
  imageClass = "object-cover w-full h-full object-center rounded-full",
  titleClass = "title text-base font-extrabold text-gray-dark",
  subtitleClass = "subtitle text-xs uppercase text-center text-gray-dark",
  placeholder = ""
}) => {
  return (
    <div
      key={`sales-team-card-${profile?.id}`}
      className={`profile-card outer-container ${outerContainerClass}`}
    >
      <div className={`${imageContainerClass}`}>
        <Image
          sourceUrl={profile?.image ?? placeholder}
          alt={profile?.name}
          imageClass={`${imageClass}`}
        />
      </div>
      <div
        className={`${titleClass}`}
        dangerouslySetInnerHTML={{ __html: profile?.name.split(" ").shift() }}
      />
      <div
        className={`${subtitleClass}`}
        dangerouslySetInnerHTML={{ __html: profile?.position }}
      />
    </div>
  );
};

export default SalesTeamCard;
